import { Construction, Info, Create } from "@mui/icons-material";

export const COLORS = {
    WHITE: "white",
    LIGHT_BLUE: "lightBlue",
    BLUE_GRAY: "blueGray",
    HEADER_BACKGROUND: "#005ab2",
};

export const ROUTES = {
    NONE: "",
    ROOT: "/",
    ABOUT_ME: "/aboutme",
    ARTICLES: "/articles",
    PROJECTS: "/projects",
};

export const THEMES = {
    DARK: "dark",
    LIGHT: "light",
};

export const PROFILE_URLS = {
    INSTAGRAM: "https://www.instagram.com/aniruddha414",
    LINKEDIN: "https://www.linkedin.com/in/aniruddha-tonge",
    GITHUB: "https://github.com/aniruddha414",
    MAIL: "aniruddhatonge98@gmail.com",
};

export const ICON_MAP = {
    info: <Info />,
    construction: <Construction />,
    create: <Create />,
};
